// Ensures a URL has a scheme so it doesn't resolve as a relative path.
export function normalizeUrl(url: string, scheme = 'https://'): string {
  if (url.includes('https://')) return url;
  return /^[a-z][a-z0-9+.-]*:/i.test(url) ? url : scheme + url;
}
